import ReactDOM from "react-dom";

import classes from "./css/Modal.module.css";

const Backdrop = (props) => {
  return <div className={classes.backdrop} onClick={props.onClose} />;
};

const ModalOverlay = (props) => {
  return (
    <div
      className={`${classes.main_modal} ${
        props.type === "dionisiache" ? classes.dionisiache : null
      }`}
    >
      <div
        className={`${classes.image_container} ${
          props.type === "dionisiache" ? classes.dionisiache : null
        }`}
      >
        <img src={props.image} alt="modale" className={classes.image_detail} />
      </div>
      <button onClick={props.onClose}>Chiudi</button>
    </div>
  );
};

const Modal = (props) => {
  return (
    <>
      {ReactDOM.createPortal(
        <Backdrop onClose={props.onClose} />,
        document.getElementById("backdrop-root")
      )}
      {ReactDOM.createPortal(
        <ModalOverlay
          showNew={props.show}
          onClose={props.onClose}
          image={props.image}
          type={props.type}
        />,
        document.getElementById("overlay-root")
      )}
    </>
  );
};

export default Modal;
